import { isToday } from 'date-fns';
import isEqual from 'lodash/fp/isEqual';

import { FlightTimeType, FlightTurnaroundDto, ResourceOccupation } from '../../../backend';

export const sortByArrivalTime = (a, b) => (a.aibt || a.eibt || a.sibt) - (b.aibt || b.eibt || b.sibt);
export const sortByDepartureTime = (a, b) =>
    (a.aobt || a.pobt || a.tobt || a.eobt || a.sobt) - (b.aobt || b.pobt || b.tobt || b.eobt || b.sobt);

export const getTurnaroundActualOccupation = (turnaround: FlightTurnaroundDto) => {
    if (turnaround) {
        return turnaround.actualOccupation;
    } else {
        return null;
    }
};

export const getTurnaroundScheduledOccupation = (turnaround: FlightTurnaroundDto) => {
    if (turnaround) {
        return turnaround.scheduledOccupation;
    } else {
        return null;
    }
};

export const isTurnaroundScheduledOrActual = (
    day: Date,
    turnaroundOccupation: ResourceOccupation,
    scheduledTurnaroundOccupation: ResourceOccupation,
) => {
    //day D + (turnaround with both times scheduled or end time actual)
    return (
        isToday(day) &&
        (isEqual(turnaroundOccupation, scheduledTurnaroundOccupation) ||
            turnaroundOccupation?.occupationEnd?.type === FlightTimeType.A)
    );
};
